// 任务分配
import request from '@/utils/request'

// /bizTaskAllocation/{id}
// 查询
export function queryById(id) {
  return request({
    url: '/bizTaskAllocation/' + id,
    method: 'get',
  })
}

// 添加
export function add(data) {
  return request({
    url: '/bizTaskAllocation/save',
    method: 'post',
    data
  })
}

// /bsProfessionalLevel/delete/{id}
// 删除
export function del(id) {
  return request({
    url: '/bizTaskAllocation/delete/' + id,
    method: 'delete'
  })
}

// /bizTaskAllocation/deleteBizJobContent/{id}
// 删除工作内容
export function delForm(id) {
  return request({
    url: '/bizTaskAllocation/deleteBizJobContent/' + id,
    method: 'delete'
  })
}
// /bsProfessionalLevel/update
// 修改
export function edit(data) {
  return request({
    url: '/bizTaskAllocation/update',
    method: 'put',
    data
  })
}
